import React from 'react';
import { Image } from '../SmallBanner/SmallBanner.styles';
import { BigImage, Label, Wrapper } from './BigBanner.styles';
import { BigBannerProps } from './BigBanner.interface';

export function BigBanner({image, imageMobile}: BigBannerProps) {
    return (
        <Wrapper>
            <Label>Desktop:</Label>
            <BigImage src={image} alt="Leaderboard image - desktop"/>
            <Label>Mobile:</Label>
            <Image src={imageMobile} alt="Leaderboard image - mobile" />
        </Wrapper>
    )
}
